<div *ngIf="debugBreakpoints" class="breakpoints">{{ breakpoint.current }}</div>

<fe-alert #coreAlert></fe-alert>
<router-outlet *ngIf="!maintenance"></router-outlet>
<fe-maintenance-standalone *ngIf="maintenance"></fe-maintenance-standalone>
<a [href]="whatsappUrl" target="_blank" rel="noopener noreferrer" class="fab">
    <img
        [src]="'images/whatsapp_icon_white.svg' | cdn"
        alt="whatsapp action button"
        class="fab-icon"
    />
</a>
